<div class="row">
    <div class="offset-md-1 col-md-10">
        <div class="row">
            <div class="form-group report-filter-group col-md-6">
                <label>Start Date:</label>
                <input type="text" class="form-control w-100" bsDatepicker [formControl]="startDate">
            </div>
            <div class="form-group report-filter-group col-md-6">
                <label>End Date:</label>
                <input type="text" class="form-control w-100" bsDatepicker [formControl]="endDate">
            </div>
        </div>
        <div class="row">
            <div *ngIf="showPledgeStatus" class="form-group report-filter-group col-md-6">
                <label>Pledge Status:</label>
                <select pledgeStatus [formControl]="pledgeStatus" class="form-control form-control w-100" name="pledgeStatus">
                    <option value="">All Pledge Statuses</option>
                </select>
            </div>
            <div *ngIf="showCompany" class="form-group report-filter-group col-md-6">
                <label>Company</label>
                <input #company type="text" class="form-control w-100" (click)="companyListModal.openModal()"
                       value="All Companies">
                <company-box *ngIf="showCompany"
                             (onCompanySelected)="companySelected($event); company.value = ($event?.noCompany ? 'All Companies' : $event?.company?.name) || 'All Companies'"></company-box>
            </div>
            <div class="form-group report-filter-group col-md-6">
                <label>Agency</label>
                <input #agency [formControl]="agencyInput" type="text" class="form-control w-100"
                       (click)="agencyListModal.open()" value='All Agencies'>
                <agency-box (onAgencySelected)="onAgencyChange($event)"></agency-box>
            </div>
            <div *ngIf="showZeroBalance" class="form-group report-filter-group col-md-6 justify-content-end">
                <label class="hideAllZeroLabel">
                    <input type="checkbox" [formControl]="hideZeroBalances"> Hide all the $0
                    Balance Allocations</label>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-2">Select Fund(s)</label>
            <div class="col-md-10 pt-2">
                <pledgeTypeCheckbox [filterByRole]="true" [control]="pledgeTypeIds" [requireOne]="true"
                                    [showSelectAll]="true"
                                    [preselectAll]="true"></pledgeTypeCheckbox>
            </div>

        </div>
        <ng-content></ng-content>
    </div>
</div>
